/**
 * @internalapi
 */
export var ExtensionMessageTarget;
(function (ExtensionMessageTarget) {
    ExtensionMessageTarget["BACKGROUND"] = "toBackground";
    ExtensionMessageTarget["PAGE"] = "toPage";
    ExtensionMessageTarget["EXTENSION"] = "toExtension";
})(ExtensionMessageTarget || (ExtensionMessageTarget = {}));
//# sourceMappingURL=ExtensionMessageTarget.js.map